const APP_DOMAIN = `${process.env.APP_DOMAIN}`;

export const AppConfig = {
  VUE_APP_TITLE: 'GongCha',
  VUE_APP_DOMAIN: APP_DOMAIN,
  VUE_APP_DOMAIN_PREFIX : '',
// VUE_APP_KAKAO: '"11d748e98b9be0b9b1f3f483e61dd8de"',      // 8863843780bcc786fdb8f56229383fc3
  VUE_APP_API_DOMAIN: APP_DOMAIN + 'gp',  // gongcha real
//   VUE_APP_API_DOMAIN: APP_DOMAIN + '',  // gongcha real
  VUE_APP_SNS_ENABLED : false,
  VUE_APP_DELIVERY_ENABLED : true,
  VUE_APP_QUICK_ORDER_ENABLED : false,
  VUE_APP_MY_MENU_ENABLED : false,
  // VUE_APP_MOBILE_ONLY : true,
  VUE_APP_MOBILE_ONLY : false,

  VUE_APP_KAKAO: {
    URL:'/v2/user/me',
    NATIVE_APP_KEY : '2bda4dc8fdc857154ce0894380930d42',
    // // gckofficial@naver.com dev / Real
    KEY : '8863843780bcc786fdb8f56229383fc3',
    REST_API_KEY : 'b1057bb3b83fc24096ff99f607b36f3a',
  },
  VUE_APP_NAVER : {
    URL : 'nid/me',
    // for tck
    ID : 'XdA0udtQxK_AU9OeXL_m'
    // // for Scott
    // ID : 'kijB0Va4Xrq_wh1gIHRn'
  },
  VUE_APP_GOOGLE: {
    ID: "306881092354-5bfo8qn4naqs1rkljahnnodl6avu0k2o.apps.googleusercontent.com",
    PW: "nAjNZG550MnrLaaIhgwyArrN"
  },
  VUE_APP_FACEBOOK: {
    ID: "5473196486054510"
  },
  // VUE_APP_JUSO_DOMAIN:'"http://www.juso.go.kr/addrlink/addrLinkApi.do"',
  // VUE_APP_ADDRESS_KEY:'"devU01TX0FVVEgyMDIwMTIwOTEwNTEzNjExMDUyMzc="',
  VUE_APP_JUSO_API:{
    GET:'https://www.juso.go.kr/addrlink/addrLinkApi.do',
    // KEY:'devU01TX0FVVEgyMDIwMTIwOTEwNTEzNjExMDUyMzc=',
    POST : 'https://www.juso.go.kr/addrlink/addrLinkApiJsonp.do',
    KEY : 'devU01TX0FVVEgyMDIxMDEyNTEwNDEyNTExMDczODE='
  },
  VUE_APP_CERTIFICATE : {
    // URL : 'https://dev-gongcha.easymembership.co.kr/pcc/pcc_request.jsp',
    URL : APP_DOMAIN + 'pcc/pcc_request.jsp',
    ID : '',
    CERT_TYPE:'H',
    RET_URL : ''
  },
  VUE_APP_PAYMENT_API:{
    URL:APP_DOMAIN + 'easypay/mobile/order_req.jsp',
  },
  VUE_APP_PAYMENT_CANCEL_API:{
    URL: APP_DOMAIN + 'easypay/mobile/order_cancel.jsp',
  },
}



// WEBPACK FOOTER //
// ./src/config/AppConfig.js